export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/a46cb40b-1cc8-4b1d-b1b5-871bb0fb0d23.png" 
                alt="CAISA S.R.L. Logo" 
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-2xl font-bold">CAISA S.R.L.</h3>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Protecting your digital privacy with advanced VPN technology. Secure, fast, and reliable connections for everyone.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 hover:border-teal-500 hover:bg-teal-500 transition-all cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 hover:border-teal-500 hover:bg-teal-500 transition-all cursor-pointer">
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 hover:border-teal-500 hover:bg-teal-500 transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full border border-gray-600 hover:border-teal-500 hover:bg-teal-500 transition-all cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('vpn-service')}
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  VPN Service
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('features')}
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Features
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group"
                >
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group">
                  <i className="ri-arrow-right-s-line text-teal-500 opacity-0 group-hover:opacity-100 transition-opacity"></i>
                  Cookie Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">© 2025 CAISA S.R.L. All rights reserved.</p>
          <div className="flex items-center gap-2">
            <p className="text-gray-400 text-sm italic">Made with security in mind</p>
            <span className="text-gray-600">|</span>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-500 text-sm transition-colors">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}